import React, { memo, useCallback, useState } from 'react';

import classnames from 'classnames';

import { createDesign, useTrans } from '@/hooks';

import './index.scss';

type Props = {
  title?: string;
  titles?: string[];
  titleColor?: string;
  titleBefore?: React.ReactNode;
  titleExtra?: React.ReactNode; //标题后额外内容
  right?: any;
  children: any;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  onChange?: (index: number) => void;
};

const { prefixCls } = createDesign('cmp-pane');

function Pane(props: Props) {
  const { t } = useTrans();
  const [selected, setSelected] = useState(0);

  const handleChange = useCallback((index: number) => {
    setSelected(index);
    props.onChange && props.onChange(index);
  }, []);

  return (
    <div
      className={classnames(prefixCls, props.className)}
      onClick={props.onClick}
      style={props.style}
    >
      <div className={`${prefixCls}__title`}>
        {props.title && (
          <div className={`${prefixCls}__title-left`} style={{ color: props.titleColor }}>
            {props.titleBefore && props.titleBefore}
            <span>{t(props.title)}</span>
            {props.titleExtra && props.titleExtra}
          </div>
        )}
        {props.titles && (
          <div className={`${prefixCls}__title-left`} style={{ color: props.titleColor }}>
            {props.titles.map((item, i) => (
              <div
                className={classnames(`${prefixCls}__title-item`, {
                  selected: selected === i,
                })}
                key={i}
                onClick={() => handleChange(i)}
              >
                {props.titleBefore && props.titleBefore}
                <span>{item}</span>
                {props.titleExtra && props.titleExtra}
              </div>
            ))}
          </div>
        )}
        <div className={`${prefixCls}__title-right`}>{props.right}</div>
      </div>
      {props.children}
    </div>
  );
}

export default memo(Pane);
